// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"31":"0a7c1e15","962":"02148fb3","966":"85833dff"}[chunkId] + ".js";
};